export class ComplyCubeError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "ComplyCubeError";
  }
}
